import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createMembershipProfileCurrency,
  deleteMembershipProfileCurrency,
} from '@store/membership/MembershipProfileCurrencyReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'

export const MembershipProfileCurrencyForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.membershipProfileCurrency)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          delete: Delete,
        }}
        handlers={{
          create: async (values) => {
            return dispatch(createMembershipProfileCurrency(values)).then(
              () => {
                return true
              }
            )
          },
          delete: async (values) => {
            return dispatch(deleteMembershipProfileCurrency(values)).then(
              () => {
                return true
              }
            )
          },
        }}
      />
    )
  }
)

MembershipProfileCurrencyForm.displayName = 'MembershipProfileCurrencyForm'

export default MembershipProfileCurrencyForm
